import { useMemo } from "react";
import {
  List,
  TextField,
  DatagridConfigurable,
  NumberField,
  useTheme,
  usePermissions,
} from "react-admin";
import DownloadAction from "../../components/tableListActions/DownloadAction";
import customerMembershipFilterList from "../../components/customerMemberships/filter/customerMembershipFilterList";

const CustomerMembershipList = () => {
  const { permissions } = usePermissions();
  const [theme] = useTheme("light");

  const list = useMemo(
    () => (
      <List
        title="Customer Membership"
        empty={false}
        actions={<DownloadAction />}
        filters={customerMembershipFilterList(permissions)}
        queryOptions={{ meta: { sort: ["customers.created_at DESC"] } }} // overide default sort
      >
        <DatagridConfigurable
          // FIXME: semua datagrid perlu pake custom bulk action ini
          bulkActionButtons={false}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {permissions && permissions.update_company ? (
            <TextField source="company.alias" label="mine.label.company" />
          ) : null}
          <TextField source="code" label="mine.label.code" />
          <TextField source="name" label="mine.label.name" />
          <NumberField source="days" label="mine.label.day" />
          <NumberField source="months" label="mine.label.month" />
          <NumberField source="years" label="mine.label.year" />
        </DatagridConfigurable>
      </List>
    ),
    [theme, permissions]
  );
  return list;
};

export default CustomerMembershipList;
